import { inject } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { AuthenticationService } from './authentication.service';

export function EntryGuard(): Observable<boolean> {
  const authService = inject(AuthenticationService);
  if (!authService.isFirstTimeLogin()) {
    return authService.handleRedirect().pipe(take(1));
  } else {
    return of(true);
  }
}
